export default "__VITE_ASSET__EeYgS__g__"